// CORE
import React, { useContext } from "react";

// THIRD-PARTY LIBRARIES
import { Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

// CONTEXT
import { Context } from "components/Form";

// HELPERS
import { addClassError, inputRegister } from "helpers/forms";

// COMPONENTS
import InputTitle from "../input-title";
import InputError from "../input-error";

// STYLES
import styles from "./styles/style.module.scss";

export const Textarea = ({
    name,
    langId = name,
    locale = "",
    rules = { required: <FormattedMessage id="requiredField" /> },
    lg = "6",
    ...rest
}) => {
    const { register, errors } = useContext(Context);
    return (
        <Col lg={lg}>
            <div className={styles["textarea-container"]}>
                <div
                    className={`textarea-wrapper  ${
                        rules?.required ? "required" : ""
                    }`}
                >
                    <InputTitle name={langId} locale={locale} />
                    <textarea
                        className={`form-control ${addClassError(
                            errors,
                            name,
                            locale
                        )}`}
                        {...inputRegister(register, name, locale, rules)}
                        {...rest}
                    ></textarea>
                    <InputError name={name} locale={locale} errors={errors} />
                </div>
            </div>
        </Col>
    );
};

export default Textarea;
